import { createContext, useContext, useEffect, useState } from 'react';
import P from 'prop-types';
import useCrud from '../../hooks/useCrud';

const FinancialContext = createContext();

export const FinancialProvider = ({ children }) => {
  const defaultBankValues = { varId: 1, value: '' };

  const { items: bancos , setItems: setBancos} = useCrud('/banks', defaultBankValues, 'SelectBancos');

  // Trecho para evitar o warning de loop infinito "Warning: Can't perform a React state update on an unmounted component."
  // O erro se refere à chamada de função assíncrona sem saber se o componente está montado ou não.

  return (
    <FinancialContext.Provider
      value={{
        bancos,
        setBancos,
      }}>
      {children}
    </FinancialContext.Provider>
  );
};

// hook para usar o contexto
export const useFinancialContext = () => {
  const context = useContext(FinancialContext);
  if (!context) {
    throw new Error('useFinancialContext deve ser usado dentro de um FinancialProvider');
  }
  return context;
};

FinancialProvider.propTypes = {
  children: P.node.isRequired,
};
